<template>

  <el-dialog v-model="model" title="Configurar Biografía" :width="anchoSidebar"
    header-class="bg-primary rounded  p-1 text-white" class="p-0 rounded-top"
    footer-class=" p-1 bg-dark w-100 d-flex rounded-bottom" @opened="refetchForm" destroy-on-close>

    <!-- header -->
    <template #header>
      <section class="w-100">
        <h3 class="text-white">{{ initialValues.id ? 'Actualizar la configuración ' : 'Configurar Biografía' }}</h3>
      </section>
    </template>
    <!-- Configuracion -->
    <b-form @submit.prevent="configurar" ref="formConfiguracion">
      <section class="d-flex content-formulario">

        <section class="formulario">

          <b-form-group>
            <template #label>
              <b class="">Tipo <span class="d-none d-lg-inline">de Biografía </span>: <span
                  class="text-danger d-none d-sm-inline">*</span></b>
            </template>

            <v-select v-model="tipo_biografia_id" v-bind="tipo_biografia_attrs" :options="tipos_biografias" label="text"
              :reduce="option => option.value" placeholder="Seleccione el tipo de Biografía">
            </v-select>

            <b-form-invalid-feedback :state="!errors.tipo_biografia_id">
              {{ errors.tipo_biografia_id }}
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group>
            <template #label>
              <b>Título para este libro : <span class="text-danger">*</span></b>
            </template>

            <b-form-input v-model="titulo" v-bind="titulo_attrs" placeholder="Título de la Biografía" size="sm" />
            <b-form-invalid-feedback :state="!errors.titulo">
              {{ errors.titulo }}
            </b-form-invalid-feedback>
          </b-form-group>


          <b-form-group>
            <template #label>
              <b>Sub título : <span class="text-danger">*</span></b>
            </template>

            <b-form-input v-model="sub_titulo" v-bind="sub_titulo_attrs" placeholder="Sub Título de la Biografía"
              size="sm" />
            <b-form-invalid-feedback :state="!errors.sub_titulo">
              {{ errors.sub_titulo }}
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group>
            <template #label>
              <b>Tono de la Biografía : <span class="text-danger">*</span></b>
            </template>

            <v-select v-model="tono" :options="optionsTono" label="text" :reduce="option => option.value"
              placeholder="Seleccione el tono de la Biografía" size="sm">
            </v-select>

            <b-form-invalid-feedback :state="!errors.tono">
              {{ errors.tono }}
            </b-form-invalid-feedback>

          </b-form-group>

          <b-form-group>
            <template #label>
              <b>Narración de la Biografía : <span class="text-danger">*</span></b>
            </template>

            <v-select v-model="narracion" :options="optionsNarracion" label="text" :reduce="option => option.value"
              placeholder="Seleccione el tipo de narración" size="sm">
            </v-select>

            <b-form-invalid-feedback :state="!errors.narracion">
              {{ errors.narracion }}
            </b-form-invalid-feedback>
          </b-form-group>


          <b-form-group>
            <template #label>
              <b>Extensión del libro : <span class="text-danger">*</span></b>
            </template>

            <v-select v-model="extension_libro" :options="optionsExtension" label="text"
              :reduce="option => option.value" placeholder="Seleccione la extensión del libro" size="sm">
            </v-select>

            <b-form-invalid-feedback :state="!errors.extension_libro">
              {{ errors.extension_libro }}
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group>
            <template #label>
              <b>¿Desea que participen terceros en la biografía? : <span class="text-danger">*</span></b>
            </template>

            <v-select v-model="participacion_tercero" v-bind="participacion_tercero_attrs" :options="optionsParticacion"
              label="text" :reduce="option => option.value" placeholder="Seleccione una opción" size="sm">
            </v-select>

            <b-form-invalid-feedback :state="!errors.participacion_tercero">
              Este campo es obligatorio.
            </b-form-invalid-feedback>
          </b-form-group>

          <!-- colaboradores -->
          <b-form-group v-if="participacion_tercero == 1">
            <template #label>
              <b>
                Colaboradores: <font-awesome-icon icon="info-circle" size="xs" color="#B49754" />
              </b>
            </template>

            <b-input-group class="d-flex flex-nowrap">

              <v-select class="flex-grow-1" v-model="invitaciones" multiple :options="colaboradores"
                :reduce="option => option.id" label="nombre" style="width: 245px">
              </v-select>

              <b-button size="sm" @click="agregarColaborador()">
                <font-awesome-icon icon="fas fa-plus" />
                <strong class="d-none d-lg-inline"> Agregar</strong>
              </b-button>
            </b-input-group>
          </b-form-group>
        </section>
        <section class="formulario">
          <!-- Autor -->

          <b-form-group>
            <template #label>
              <b>Nombre del autor : <span class="text-danger">*</span></b>
            </template>

            <b-form-input v-model="nombre_autor" v-bind="nombre_autor_attrs" placeholder="Jhon" size="sm" />
            <b-form-invalid-feedback :state="!errors.nombre_autor">
              El nombre del autor es Obligatorio.
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group>
            <template #label>
              <b>Apellido del autor : <span class="text-danger">*</span></b>
            </template>

            <b-form-input v-model="apellido_autor" v-bind="apellido_autor_attrs" placeholder="Doe" size="sm" />
            <b-form-invalid-feedback :state="!errors.apellido_autor">
              El apellido del autor es Obligatorio.
            </b-form-invalid-feedback>
          </b-form-group>

        </section>


      </section>
      <!-- end configuracion -->


    </b-form>

    <!-- footer dialog -->
    <template #footer>
      <b-button-group :vertical="['xs', 'sm'].includes(currentBreakPoint)" class="btn-actions">
        <b-button v-loading="loading" title="Configurar Libro" variant="secondary"
          class="d-flex flex-wrap align-items-center justify-content-center" @click="configurar">
          <font-awesome-icon icon="fas fa-paper-plane" class="me-sm-1 mb-1 mb-sm-0 " size="lg" />
          <strong class="d-inline text-nowrap text-center "> {{ initialValues.id ? "Actualizar Configuración" :
            'Iniciar Biografía' }}</strong>
        </b-button>

      </b-button-group>
    </template>
    <drawer-form-colaborador v-model="showFormColaborador" :titulo="titulo" @invitacion-enviada="invitacionEnviada"
      :configuracion-id="configuracion_id"></drawer-form-colaborador>
  </el-dialog>
</template>

<script setup>
import useFormConfiguracion from './useFormConfiguracion';
import useAppStore from '@/store/app';
import useRootStore from '@/store/root';


const app_store = useAppStore();
const root_store = useRootStore();
import DrawerFormColaborador from './colaboradores/DrawerFormColaborador.vue';

const {loading} = storeToRefs(root_store);
const { currentBreakPoint,anchoSidebar } = storeToRefs(app_store);

const model = defineModel({
    type: Boolean,
    default: false
});

const emits = defineEmits(['save']);

const formConfiguracion = ref(null);

const {

  // state
  initialValues,
  optionsParticacion,
  optionsExtension,
  optionsNarracion,
  optionsTono,
  tipos_biografias,
  errors,
  colaboradores,
  showFormColaborador,
  configuracion_id,

  // Form
  tipo_biografia_id,
  tipo_biografia_attrs,
  paginas,
  paginas_attrs,
  titulo,
  titulo_attrs,
  sub_titulo,
  sub_titulo_attrs,
  participacion_tercero,
  participacion_tercero_attrs,
  tono,
  tono_attrs,
  narracion,
  narracion_attrs,
  extension_libro,
  extension_libro_attrs,
  invitaciones,
  invitaciones_attrs,
  nombre_autor,
  nombre_autor_attrs,
  apellido_autor,
  apellido_autor_attrs,

  invitacionEnviada,


  //methods
  configurar,
  agregarColaborador,
  refetchForm
} = useFormConfiguracion(model);



</script>

<style lang="scss" scoped>

.btn-actions {
  width: 100%;
}

.content-formulario {
  padding: 5px 5px;
  display: flex;
  flex-direction: column;
  .formulario {
    display: flex;
    flex-wrap: wrap;
    position: relative;
    width: 100%;

    &:deep(.b-form-group) {
      position: relative;
      flex: 1 0 250px;
      margin: 5px 5px;
      min-height: 103px;
      // max-width:490px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
    }
  }
}


@media (min-width:450px) {
  .content-formulario {
    padding: 20px;

    .formulario {
      display: flex;
      flex-wrap: wrap;
      position: relative;
      width: 100%;

      &:deep(.b-form-group) {
        position: relative;
        flex: 1 0 350px;
      }
    }
  }
}

@media (min-width:762px) {
  .btn-actions {
    width: auto;
  }
}
</style>